/* eslint-disable react-hooks/exhaustive-deps */
import { useDynamicFormFieldById } from 'components/DynamicForm/state';
import { SimpleCheckBox } from 'components/InputsMex/SimpleInputs';
import SimpleContainer from 'components/InputsMex/containers/SimpleContainer';
import { Label } from 'components/InputsMex/containers/components';
import {
  DropDown,
  DropDownDate,
  DropDownFilter,
  HideField,
  NumberInput,
  ObjectViewPathField,
  PrimeTextInput,
  TextInputMask,
} from 'components/InputsMex/inputs';
import useForceUpdate from 'hooks/useForceUpdate';
import React, { useEffect, useMemo, useState } from 'react';
import Archivos from '../Archivos';
import ComplienceQuestionsInput from '../ComplienceQuestions';
import Geolocalizacion from '../Geolocalizacion';
import ShowOnFieldWrapper from '../ShowOnFieldWrapper';
import UbicacionInput from '../Ubicacion';
import { YesNoComponent } from '../YesNoComponent/YesNoComponent';

const DEFAULT_COLS_CLASS_NAME = 'col-md-6 col-xl-5 my-2';

const Select = ({ containerProps, rest }) => {
  const { field } = useDynamicFormFieldById({ fieldId: rest.id });

  useForceUpdate([field]);

  return (
    <div className={containerProps?.colsClassNames || DEFAULT_COLS_CLASS_NAME}>
      {/* {rest.name === 'regimenFiscal' && field.options?.length} */}
      <SimpleContainer {...containerProps}>
        <DropDownFilter {...rest} options={field?.options} />
      </SimpleContainer>
    </div>
  );
};

/**
 *
 * @param {{campos:import("components/DynamicForm/typedefs").Campo[]}} param0
 * @returns
 */
const Campos = ({ campos }) => {
  const [camposGenerados, setCamposGenerados] = useState([]);

  const { tick } = useForceUpdate([]);

  useEffect(() => {
    const newCampos = campos
      ?.map?.((campo) => {
        const { containerProps, ...rest } = campo;
        let Component = null;
        switch (campo.type) {
          case 'email':
            Component = () => (
              <div className={containerProps?.colsClassNames || DEFAULT_COLS_CLASS_NAME}>
                <SimpleContainer {...containerProps}>
                  <PrimeTextInput {...rest} keyfilter="email" />
                </SimpleContainer>
              </div>
            );
            break;

          case 'string':
          case 'text':
          case 'texto':
            Component = () => (
              <div className={containerProps?.colsClassNames || DEFAULT_COLS_CLASS_NAME}>
                <SimpleContainer {...containerProps}>
                  <PrimeTextInput {...rest} />
                </SimpleContainer>
              </div>
            );
            break;

          case 'number':
          case 'numberInt':
          case 'numberDecimal':
            Component = () => (
              <div className={containerProps?.colsClassNames || DEFAULT_COLS_CLASS_NAME}>
                <SimpleContainer {...containerProps}>
                  <NumberInput {...rest} />
                </SimpleContainer>
              </div>
            );
            break;

          case 'select':
          case 'dropdown':
            Component = () => <Select containerProps={containerProps} rest={rest} />;
            break;

          case 'YesNoSelect':
          case 'SiNoSelect':
            Component = () => (
              <div className={containerProps?.colsClassNames || DEFAULT_COLS_CLASS_NAME}>
                <SimpleContainer {...containerProps}>
                  <DropDown
                    {...rest}
                    options={[
                      { label: 'SI', value: 'SI' },
                      { label: 'NO', value: 'NO' },
                    ]}
                  />
                </SimpleContainer>
              </div>
            );
            break;

          case 'fecha':
          case 'date':
            Component = () => (
              <div className={containerProps?.colsClassNames || DEFAULT_COLS_CLASS_NAME}>
                <SimpleContainer {...containerProps}>
                  <DropDownDate {...rest} />
                </SimpleContainer>
              </div>
            );
            break;

          case 'ubicacionAigMex':
            Component = () => <UbicacionInput configuracion={rest?.configuracion} {...rest} />;
            break;

          case 'mask':
            Component = () => (
              <div className={containerProps?.colsClassNames || DEFAULT_COLS_CLASS_NAME}>
                <SimpleContainer {...containerProps}>
                  <TextInputMask {...rest} />
                </SimpleContainer>
              </div>
            );
            break;
          case 'complienceQuestions':
            Component = () => (
              <ComplienceQuestionsInput configuracion={rest?.configuracion} {...rest} />
            );
            break;

          case 'checkbox':
            Component = () => (
              <div className={containerProps?.colsClassNames || DEFAULT_COLS_CLASS_NAME}>
                <SimpleCheckBox
                  id={rest.name}
                  name={rest.name}
                  rules={rest.rules}
                  label={rest.label}
                  defaultValue={rest?.defaultValue}
                  disabled={rest?.disabled === true}
                />
              </div>
            );
            break;
          case 'geolocalizacion':
            Component = () => <Geolocalizacion {...rest} />;
            break;

          case 'objectViewField':
            Component = () => (
              <div className={containerProps?.colsClassNames || DEFAULT_COLS_CLASS_NAME}>
                <SimpleContainer {...containerProps}>
                  <ObjectViewPathField {...rest} />
                </SimpleContainer>
              </div>
            );
            break;

          case 'hidden':
            Component = () => <HideField {...rest} />;
            break;

          case 'YesNo':
            Component = () => <YesNoComponent {...rest} />;
            break;

          case 'descripcion':
            Component = () => (
              <Label className="p-3" style={{ fontSize: '20px' }}>
                {rest?.label}
              </Label>
            );
            break;
          case 'archivos':
            const { producto = 'default', ...campoProps } = campo;
            Component = () => <Archivos producto={producto} campo={campoProps} />;
            break;
          default:
            Component = () => <p>Tipo {rest.type} no implementado</p>;
            break;
        }

        if (rest?.showOn) {
          return (
            <ShowOnFieldWrapper
              id={rest?.id}
              name={rest?.name}
              showOnConfig={rest?.showOn}
              key={rest?.id}
            >
              {({ showField }) => (showField ? <Component /> : null)}
            </ShowOnFieldWrapper>
          );
        }
        return <Component key={rest?.id} />;
      })
      .filter((campo) => campo);
    setCamposGenerados(newCampos);
  }, [campos, tick]);

  return <React.Fragment>{camposGenerados}</React.Fragment>;
};

export default Campos;
